import { mapStore } from "../store";

export function updateExpandedLHS(val: boolean) {
  mapStore.expandedLHS = val;
}
